export default "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><path d=\"M1 2h14v2H1V2ZM1 7h14v2H1V7ZM15 12H1v2h14v-2Z\"/></svg>";